import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import {createStore} from 'redux'
import allReducer from './reducers'
import { Provider } from 'react-redux'
import { unregister as unRegisterServiceWorker } from './serviceWorkerRegistration';

const ignoredResizeObserverErrors = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

const getResizeObserverMessage = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value?.message === 'string') return value.message;
  return String(value);
};

const shouldIgnoreResizeObserverError = (value) => {
  const message = getResizeObserverMessage(value);
  return ignoredResizeObserverErrors.some((ignoredMessage) => message.includes(ignoredMessage));
};

const hideResizeObserverOverlay = () => {
  const overlayIds = [
    'webpack-dev-server-client-overlay',
    'webpack-dev-server-client-overlay-div',
  ];

  overlayIds.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = 'none';
    }
  });
};

window.addEventListener('error', (event) => {
  if (shouldIgnoreResizeObserverError(event.message) || shouldIgnoreResizeObserverError(event.error)) {
    hideResizeObserverOverlay();
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (shouldIgnoreResizeObserverError(event.reason)) {
    hideResizeObserverOverlay();
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const originalConsoleError = console.error;
console.error = (...args) => {
  if (args.some((arg) => shouldIgnoreResizeObserverError(arg))) {
    hideResizeObserverOverlay();
    return;
  }

  originalConsoleError(...args);
};

// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() s an extension that allows us to see state changes in the browser
const store = createStore(allReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
// import reportWebVitals from './reportWebVitals';

ReactDOM.render(
   <BrowserRouter>
     <Provider store={store}>
       <App />
     </Provider>
 </BrowserRouter>,
  document.getElementById('root')
);
unRegisterServiceWorker();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
